
import {countryCodes} from './country-codes'


export function validateIpAddress (ipAddress) {
  if (!ipAddress || ipAddress === '') return false
  var ipFormat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/

  return ipAddress.match(ipFormat)
}

export function validateIpAddressesOnSameSubnet (ipAddresses, maskSize) {
  let masked = null
  for (let iAddr = 0; iAddr < ipAddresses.length; iAddr++) {
    let currentMasked = ipToNumber(ipAddresses[iAddr]) & ipMask(maskSize)
    if (masked) {
      if (currentMasked !== masked) {
        return false
      }
    } else {
      masked = currentMasked
    }
  }
  return true
}

export function hasDuplicate (array) {
  let seen = []
  for (let iElem = 0; iElem < array.length; iElem++) {
    let elem = array[iElem]
    if (seen.includes(elem)) {
      return true
    }
    seen.push(elem)
  }

  return false
}

export function validatePort(port) {
  if (port < 1 || port > 65635) return false
  return true
}

export function validateClusterSshPort(port) {
  if (port == 22) {return true}
  return port >= 1023 && port <= 65635
}

export function validateServerNamePort(serverName) {
  var chars = /^[0-9a-zA-Z.:]+$/
  return (serverName.match(chars))
}

export function validateCountryCode(countryCode) {
  return countryCode.toUpperCase() in countryCodes
}

function ipToNumber (IPaddress) {
  var ip = IPaddress.match(/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/)
  if (ip) {
    return (+ip[1] << 24) + (+ip[2] << 16) + (+ip[3] << 8) + (+ip[4])
  }
  return null
}

function ipMask (maskSize) {
  return -1 << (32 - maskSize)
}

export function validateAlphanumeric(text) {
  let letters = /^[0-9a-zA-Z]+$/
  return text.match(letters) != null
}

export function validateAlphanumericLower(text) {
  let letters = /^[0-9a-z]+$/
  return text.match(letters) != null
}

export function validateAlphanumericWithExtras(text) {
  let letters = /^[0-9a-zA-Z_ ]+$/
  return text.match(letters) != null
}

export function validateAlphanumericWithExtras2(text) {
  let letters = /^[0-9a-zA-Z_.-]+$/
  return text.match(letters) != null
}

export function validateUsername(text) {
  var letters = /^[0-9a-zA-Z_]+$/
  return (text.match(letters))
}

export function validateHostName(text) {
  if (!text || text[0] == '-') return false
  let letters = /^[0-9a-z.-]+$/
  return text.match(letters) != null
}

export function validateHostNamePort(text) {
  let splitted = text.split(':')
  if (splitted.length > 2 ) return false
  if (splitted.length == 1) return validateHostName(text)
  if (splitted.length == 2) return validateHostName(splitted[0]) && validatePort(splitted[1])
}

export function validateTenantName(text) {
  if (!text || text[0] == '-') return false
  let letters = /^[0-9a-zA-z.-]+$/
  return text.match(letters) != null
}

export function validateDomainNamePattern(text) {
  if (!text || text[0] == '-') return false
  let letters = /^[0-9a-z.*-]+$/
  return text.match(letters) != null
}

export function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email)
}

export function validateUrl(url) {
  const re = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/
	return re.test(url)
}

export function validateDirectoryPath(text) {
  if (!text || text.length == 0) return false
  let letters = /^[0-9a-z_//]+$/
  return text.match(letters) != null
}

export function validateTime(timeStr) {
  if (!timeStr || timeStr.length == 0) return false

  let splitted = timeStr.split(':')
  if(splitted.length > 2) {
      return false
  }
  if (splitted.length == 1) {
    param.value += ':00'
    splitted.push('00')
  }
  if (splitted[0].length > 2 || splitted[1].length > 2) {
    return false
  }
  let hours = parseInt(splitted[0])
  let minutes = parseInt(splitted[1])
  if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {

    return false
  }

  return true
}

export function validatePassword(passwd) {
  if (passwd.length < 12) {
    return 'too_short'
  }
  if (! /[A-Z]/       .test(passwd)) {
    return 'must_contain_uppercase_letter'
  }
  if (! /[a-z]/       .test(passwd)) {
    return 'must_contain_lowercase_letter'
  }
  if (! /[0-9]/       .test(passwd)) {
    return 'must_contain_number'
  }
  if (! /[ `!@#$%^&*()_+\-=\[\]{}':"\\|,.<>\/?~]/   .test(passwd)) {
    return 'must_contain_special_char'
  }
  return null
}

export function timestampToDatetime(timestamp) {
  var date = new Date(timestamp * 1000)
  return date.toLocaleString()
}

export function arrayToKeyValue(valArray) {
  if (valArray === undefined || valArray === null || valArray === '') return []
  if (valArray.length == 1 && valArray[0] == [""]) {
    return []
  }
  return valArray.map(val => {return {key: val, value: val}})
}

export function dictToKeyValue(dict) {
  if (dict === undefined || dict === null || typeof dict !== 'object') return [];
  let res = []
  for (const [gk, gv] of Object.entries(dict)) {
    res.push({key: gk, value: gv})
  }
  return res
}

export function fromKeyValueToArray(keyValArray) {
  if (keyValArray == undefined || keyValArray == null || !Array.isArray(keyValArray)) return [];
  return keyValArray.map(keyValObj => keyValObj.value)
}

export function fromKeyValueToDict(keyValArray) {
  let res = {}
  if (keyValArray == undefined || keyValArray == null || !Array.isArray(keyValArray) ) return res;
  for (let elem of keyValArray) {
    res[elem['key']] = elem['value']
  }
  return res
}

export function generateRandomChars(len) {
  const chars = '0123456789abcdefghijklmnopqrstvwxyz'
  let output = ''
  for (let i = 0; i < len; ++i) {
      output += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return output
}
